import { bootstrap } from '@bootstrap';

bootstrap()

declare global {
    interface Window {
        M: {
            theme_soon?: {
                uuid_v4?: () => string
                events?: {
                    emit: (event: string, data: any) => void
                    on: (event: string, callback: (event?: any) => void) => void
                    off: (event: string, callback: (event?: any) => void) => void
                },
            }
        }
    }
}

